module.exports = __webpack_public_path__ + "fasaw2.png?04c0b35655dd8d06998f568a08d79d55";